import $ from 'jquery';

$.fn.extend({
  loadCatalogPromotionScopeConfiguration(target) {
    const targetElement = target;
    if (
      targetElement == null ||
      targetElement.querySelector('#sylius_catalog_promotion_scopes select[name*="type"]') == null
    ) {
      return;
    }

    targetElement.querySelector('#sylius_catalog_promotion_scopes select[name*="type"]').onchange = function () {
      const parent = this.parentElement.parentElement;
      const newConfig = document.createElement('div');
      newConfig.innerHTML = this.selectedOptions[0].getAttribute('data-configuration');
      const oldConfig = parent.nextElementSibling;

      parent.parentElement.replaceChild(newConfig, oldConfig);

      const oldConfigInputName = oldConfig.querySelector('input').getAttribute('name');
      let newConfigInputName = newConfig.querySelector('input').getAttribute('name');

      newConfigInputName = oldConfigInputName.replace(
        oldConfigInputName.substring(oldConfigInputName.lastIndexOf('[') + 1, oldConfigInputName.lastIndexOf(']')),
        newConfigInputName.substring(newConfigInputName.indexOf('[') + 1, newConfigInputName.lastIndexOf(']')),
      );

      $(newConfig).find('input').attr('name', newConfigInputName);
      $(newConfig).find('.sylius-autocomplete').autoComplete();
    };
  },
});
